module.exports = "<div *ngIf=\"message\" role=\"alert\" [ngClass]=\"{ 'alert alert-dismissible fade show': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\">{{message.text}}\r\n  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" (click)=\"hideAlert()\" aria-label=\"Close\">\r\n    <span aria-hidden=\"true\">&times;</span>\r\n  </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/alert/alert.component.html
// module id = ./src/app/shared/alert/alert.component.html
// module chunks = main